import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { utilReducer } from './utils.action';
import { initialUtilState } from './utils.state';
import { UtilsEffects } from './utils.effects';
import { ApplicationService } from '../../shared/services/application.service';
import { RbacEffects } from './rbac/rbac.effects';
import { CommonEffects } from './common/common.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule,
        StoreModule.forFeature('util', utilReducer, {
            initialState: initialUtilState
        }),
        EffectsModule.forFeature([UtilsEffects, RbacEffects, CommonEffects])
    ],
    exports: [],
    providers: [ApplicationService]
})
export class UtilModule {}
